import { render } from "./clientTotal.vue?vue&type=template&id=049bec2a"
import script from "./clientTotal.vue?vue&type=script&lang=js"
export * from "./clientTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__